import {
  GET_LIST,
  GET_MANY,
  GET_ONE,
  UPDATE,
  CREATE,
  DELETE,
} from 'react-admin';
import { rolesFields } from './roles.model';
import queryString from 'query-string';
import { getApiUrlForResource } from '../services/apiUrlResolver';

export const ROLES_RESOURCE_NAME = 'roles';

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource(ROLES_RESOURCE_NAME);

export const providerRequestToHttpRequest = (requestType, requestParams) => {
  return providerRoleRequestToHttpRequest(requestType, requestParams, false);
};

export const providerRoleRequestToHttpRequest = (
  requestType,
  requestParams,
  all,
) => {
  // Handle permissions sub-resource
  if (requestParams.meta?.subResource === 'permissions') {
    if (requestType === GET_LIST) {
      return {
        url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}/${requestParams.filter.id}/permissions`
      };
    }
    if (requestType === UPDATE) {
      return {
        url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}/${requestParams.id}/permissions`,
        options: {
          method: 'PUT',
          body: JSON.stringify(requestParams.data),
          headers: {
            'Content-Type': 'application/json',
          },
        }
      };
    }
  }

  switch (requestType) {
    case GET_LIST: {
      return composeGetRolesListRequest(requestParams, all);
    }
    case GET_ONE: {
      return {
        url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}/${requestParams.id}`,
      };
    }
    case GET_MANY: {
      const query = {
        all: all,
        filters: JSON.stringify([
          { name: 'id', comparison: 'in', value: requestParams.ids },
        ]),
      };
      return {
        url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}?${queryString.stringify(query)}`,
      };
    }
    case UPDATE:
      return {
        url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}/${requestParams.id}`,
        options: {
          method: 'PUT',
          body: JSON.stringify(requestParams.data),
          headers: {
            'Content-Type': 'application/json',
          },
        },
      };
    case CREATE:
      return {
        url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}`,
        options: { method: 'POST', body: JSON.stringify(requestParams.data) },
      };
    case DELETE:
      return {
        url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}/${requestParams.id}`,
        options: { method: 'DELETE' },
      };
    default:
      throw new Error(`Unsupported fetch action type ${requestType}`);
  }
};

const httpResponseToProviderData = (
  httpResponse,
  requestType,
  requestParams,
) => {
  let { headers, json } = httpResponse;
  switch (requestType) {
    case GET_LIST:
      return {
        data: json.map((roleItem) => roleItem),
        total: parseInt(headers.get('content-range').split('/').pop()),
      };
    case GET_MANY:
      let roleIdsToGet = requestParams.ids;
      return {
        data: json.filter((roleItem) => roleIdsToGet.includes(roleItem.id)),
      };
    case UPDATE:
      // Special handling for permissions sub-resource update
      if (requestParams.meta?.subResource === 'permissions') {
        return {
          data: {
            ...json,
            id: requestParams.id,
          },
        };
      }
      return {
        data: json,
      };
    default:
      return { data: json };
  }
};

const composeGetRolesListRequest = (requestParams, all) => {
  const { page, perPage } = requestParams.pagination;
  const { field, order } = requestParams.sort;
  let prepareFilters = () => {
    let requestFilters = requestParams.filter;
    if (requestFilters === undefined) {
      return {};
    }
    let createContainsFilter = (name, value) => ({
      name,
      comparison: 'contains',
      value,
    });

    let resultFilters = [];
    // append "name" filter
    if (requestFilters.hasOwnProperty(rolesFields.roleName)) {
      resultFilters.push(
        createContainsFilter('roleName', requestFilters[rolesFields.roleName]),
      );
    }
    if (requestFilters.hasOwnProperty(rolesFields.lineType)) {
      resultFilters.push(
        createContainsFilter('lineType', requestFilters[rolesFields.lineType]),
      );
    }

    return resultFilters;
  };
  const queryParams = {
    all: all,
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage]),
    filters: JSON.stringify(prepareFilters()),
  };
  return {
    url: `${getApiUrl()}/${ROLES_RESOURCE_NAME}?${queryString.stringify(queryParams)}`,
  };
};

export default {
  resource: ROLES_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest,
    httpResponseToProviderData,
  },
};
